function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e6c32b1a-b5d7-404a-8658-1f4f538f5e89{fill:#112035;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "e6c32b1a-b5d7-404a-8658-1f4f538f5e89 circles__top-right",
  cx: 899,
  cy: 174,
  r: 102
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "e6c32b1a-b5d7-404a-8658-1f4f538f5e89 circles__bottom-right",
  cx: 798,
  cy: 463,
  r: 38
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "e6c32b1a-b5d7-404a-8658-1f4f538f5e89 circles__top-left",
  cx: 712,
  cy: 40,
  r: 72
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "e6c32b1a-b5d7-404a-8658-1f4f538f5e89 circles__bottom-left",
  cx: 313,
  cy: 500,
  r: 40
});

function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b7afd232-2a3a-42da-9cda-3ed9ab0a8e84",
    "data-name": "visual",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.9317ea2e.svg";
export { ForwardRef as ReactComponent };